var map = {
	"./": "./src/assets/icons/index.tsx",
	"./activity.svg": "./src/assets/icons/activity.svg",
	"./check-circle.svg": "./src/assets/icons/check-circle.svg",
	"./closeIcon.svg": "./src/assets/icons/closeIcon.svg?85bd",
	"./delete.svg": "./src/assets/icons/delete.svg?549b",
	"./downArrowImg.svg": "./src/assets/icons/downArrowImg.svg?69aa",
	"./errorImg.svg": "./src/assets/icons/errorImg.svg?a37c",
	"./g_hat.svg": "./src/assets/icons/g_hat.svg?6790",
	"./index": "./src/assets/icons/index.tsx",
	"./index.tsx": "./src/assets/icons/index.tsx",
	"./mediaIcon.svg": "./src/assets/icons/mediaIcon.svg?3630",
	"./notificationImg.svg": "./src/assets/icons/notificationImg.svg",
	"./on.activity.svg": "./src/assets/icons/on.activity.svg",
	"./on.premium.svg": "./src/assets/icons/on.premium.svg?4665",
	"./on.profile.svg": "./src/assets/icons/on.profile.svg",
	"./premium.svg": "./src/assets/icons/premium.svg?fe51",
	"./profile.svg": "./src/assets/icons/profile.svg",
	"./search.svg": "./src/assets/icons/search.svg?f85e",
	"./shoppingCart.svg": "./src/assets/icons/shoppingCart.svg?1aa2",
	"./successIcon.svg": "./src/assets/icons/successIcon.svg",
	"./upArrowImg.svg": "./src/assets/icons/upArrowImg.svg?1dda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";